import React, {Component} from 'react'
import {findData, findNext, findPrevious, getData} from "../util/DataProvider"
import {getPicturePathLargeImage} from "../util/CommonUtils";

const ALL_INDICATOR = "ALL";

class ProductDetails extends Component {
    state = {
        itemInfo: {}, currentPosition: 0, filter: {
            searchText: null,
            company: null,
            category: null

        }
    };

    async componentDidMount() {

        const urlSearchString = window.location.search;

        const params = new URLSearchParams(urlSearchString);

        const searchTextParam = params.get('filter.search');
        const categoryParam = params.get('filter.category');
        const companyParam = params.get('filter.company');

        const itemParam = params.get('item');

        if (categoryParam) {
            this.state.filter.category = categoryParam;
        }
        if (companyParam) {
            this.state.filter.company = companyParam;
        }
        if (searchTextParam) {
            this.state.filter.searchText = searchTextParam;
        }

        const item = await findData(false, itemParam);
        let allItems = await getData();
        let displayedItems = this.getDisplayedItems(allItems, this.state.filter);

        let foundIndex = 0;
        for (let i = 0; i < displayedItems.length; i++) {
            let found = displayedItems[i]["Name"] === itemParam;
            if (found) {
                foundIndex = i;
                break;
            }
        }

        this.state = {
            itemInfo: item,
            currentPosition: foundIndex,
            filter: this.state.filter,
            itemList: displayedItems
        };
        this.setState(this.state);

    }

    getDisplayedItems(items, filter) {
        let displayedItems;
        let searchText = filter.searchText;
        let company = filter.company;
        let category = filter.category;

        if (searchText || company || category) {
            displayedItems = items.filter(item => this.match(item, filter));
        } else {
            displayedItems = Array.from(items);
        }

        return displayedItems;
    }

    match(item, filter) {
        let searchText = filter.searchText;
        let match = true;

        if (searchText) {
            if (item.Company.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                match = true;
            } else {
                match = (item.Name.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
            }
        }
        if (match) {
            let company = filter.company;
            if (company !== ALL_INDICATOR) {
                match = item.Company === company;
            }
        }

        if (match) {
            let category = filter.category;
            if (category !== ALL_INDICATOR) {
                match = item.Category === category;
            }
        }

        return match;


    }


    getPicturePath(item) {
        return getPicturePathLargeImage(this.getCategory(), this.getCompany(), this.getModel());
    }

    getModel() {
        return this.state.itemInfo["Name"]
    }

    getCompany() {
        return this.state.itemInfo["Company"];
    }

    getCategory() {
        return this.state.itemInfo["Category"];
    }

    getEstimatedValue() {
        return this.state.itemInfo["Value"];
    }

    first = async () => {
        const item = this.state.itemList[1];
        this.state.currentPosition = 1;
        this.state.itemInfo = item;
        this.setState(this.state);

    }

    forward = async () => {
        var currentPosition = this.state.currentPosition;
        if (currentPosition >= this.state.itemList.length - 1) {
            return;
        }
        currentPosition++;
        const item = this.state.itemList[currentPosition];

        this.state.currentPosition = currentPosition;
        this.state.itemInfo = item;
        this.setState(this.state);
    }

    backward = async () => {
        var currentPosition = this.state.currentPosition;
        if (currentPosition === 0) {
            return;
        }
        currentPosition--;
        const item = this.state.itemList[currentPosition];

        this.state.currentPosition = currentPosition;
        this.state.itemInfo = item;
        this.setState(this.state);
    }

    last = async () => {
        const listLength = this.state.itemList.length;
        const item = this.state.itemList[listLength - 1];
        this.state.currentPosition = listLength - 1;
        this.state.itemInfo = item;
        this.setState(this.state);

    }

    startOfListReached() {
        return this.state.currentPosition === 1;
    }

    endOfListReached() {
        if (this.state.itemList) {
            return this.state.currentPosition >= this.state.itemList.length - 1;
        } else {
            return true;
        }

    }

    getItemListLength() {
        if (this.state.itemList) {
            return this.state.itemList.length - 1;
        } else {
            return 0;
        }
    }

    currentPosition() {
        return "" + this.state.currentPosition + " / " + this.getItemListLength();
    }

    render() {
        return <div className="item-details-main">

            <div className="item-details-info">
                <span className="card-title">{this.getModel()}</span>

                <table className="table card-info" border="true">
                    <tbody>
                    <tr>
                        <td>Company:</td>
                        <td>{this.getCompany()}</td>
                    </tr>
                    <tr>
                        <td>Category:</td>
                        <td>{this.getCategory()}</td>
                    </tr>
                    <tr>
                        <td>Value:</td>
                        <td>{this.getEstimatedValue()} Euro</td>
                    </tr>
                    </tbody>

                </table>

                <div nowrap className="navigation">
                    <button disabled={this.startOfListReached()} onClick={this.first}
                            className="start-of-list-button navigation-button btn btn-primary btn-sm">&#8249;&#8249;
                    </button>
                    <button disabled={this.startOfListReached()} onClick={this.backward}
                            className="backward-button navigation-button btn btn-primary btn-sm">&#8249;
                    </button>

                    <span className="current-position"> {this.currentPosition()}</span>

                    <button disabled={this.endOfListReached()} onClick={this.forward}
                            className="forward-button navigation-button btn btn-primary btn-sm">&#8250;
                    </button>
                    <button disabled={this.endOfListReached()} onClick={this.last}
                            className="end-of-list-button navigation-button btn btn-primary btn-sm">&#8250;&#8250;
                    </button>
                </div>
            </div>

            <div className="card-img-details-main">
                <img src={this.getPicturePath()}
                     onError={(e) => {
                         e.target.src = '/assets/images/not_yet_available.jpg'
                         // e.target.style = 'padding: 8px; margin: 16px; filter: brightness(200%)'
                     }}
                     className="card-img-details-image" alt="..."/>
            </div>
        </div>
    }
}

export default ProductDetails;
